import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState, } from "react";
import { Divider, Group, Menu, Stack, Text, UnstyledButton, } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons";
import BoxContainer from "./BoxContainer";
import { Check } from "./assets/icons.generated";
import { TEXT_COLOR } from "./theme/colors";
import { WEIGHT_BOLD } from "./theme/typography";
const SelectMenu = ({ title, items, selectedItem, bottomItems = [], w = 260, }) => {
    const [activeItem, setActiveItem] = useState(items[0]);
    useEffect(() => {
        setActiveItem((current) => {
            var _a;
            return ((_a = items.find((item) => item.label === selectedItem || item.value === selectedItem)) !== null && _a !== void 0 ? _a : current);
        });
    }, [selectedItem]);
    return (_jsxs(Menu, { position: "bottom-start", width: w, children: [_jsx(Menu.Target, { children: _jsx(UnstyledButton, { w: w, children: _jsx(BoxContainer, { p: "4px 12px", children: _jsxs(Group, { align: "center", spacing: 8, noWrap: true, position: "apart", children: [_jsxs(Stack, { spacing: 0, children: [_jsx(Text, { size: "xs", color: TEXT_COLOR.SECONDARY, children: title }), _jsx(Text, { size: "sm", fw: WEIGHT_BOLD, children: activeItem.selectedLabel || activeItem.label })] }), _jsx(IconChevronDown, { size: 16 })] }) }) }) }), _jsxs(Menu.Dropdown, { w: 260, children: [_jsx(MenuItems, { items: items, onActive: (item) => setActiveItem(item), activeItem: activeItem }), bottomItems.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Divider, { mx: "sm" }), _jsx(MenuItems, { items: bottomItems, onActive: (item) => setActiveItem(item), activeItem: activeItem })] }))] })] }));
};
const MenuItems = ({ items, onActive, activeItem, }) => {
    return (_jsx(_Fragment, { children: items.map((item, idx) => {
            const { label, onClick, ...rest } = item;
            return (_jsx(Menu.Item, { ...rest, onClick: (event) => {
                    onActive(item);
                    onClick === null || onClick === void 0 ? void 0 : onClick(event);
                }, children: _jsxs(Group, { position: "apart", children: [label, label === activeItem.label && _jsx(Check, {})] }) }, idx));
        }) }));
};
export default SelectMenu;
